module.exports = __webpack_public_path__ + "img/info-circle.a44fba96.svg";